import { newShortId } from '@beamible/uuid';
import useNextColor from '@pkg/entities/tags/useNextColor';
import { DesignEntity } from '@/lib/enums';

/**
 * @param {Object} state
 * @param {Object[]} state.categories
 * @returns {Object}
 */
export default function add({ categories }, properties) {
  const defaultTaggables = [
    DesignEntity.GROUP,
    DesignEntity.ROLE,
    DesignEntity.ACTIVITY,
  ];

  const category = {
    uuid: properties?.uuid || newShortId(),
    name: properties?.name || 'New category',
    color: properties?.color || useNextColor(categories.list),
    order: categories.list.length,
    taggables: properties?.taggables || defaultTaggables,
  };

  return {
    categories: {
      create: [category],
    },
  };
}
